"use strict";

var _classCallCheck = require("/opt/mvi_website/deployed/AccountsWebsite.831/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/mvi_website/deployed/AccountsWebsite.831/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/mvi_website/deployed/AccountsWebsite.831/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/mvi_website/deployed/AccountsWebsite.831/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/opt/mvi_website/deployed/AccountsWebsite.831/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var BottleneckError;

BottleneckError = /*#__PURE__*/function (_Error) {
  _inherits(BottleneckError, _Error);

  function BottleneckError() {
    _classCallCheck(this, BottleneckError);

    return _possibleConstructorReturn(this, _getPrototypeOf(BottleneckError).apply(this, arguments));
  }

  return BottleneckError;
}(_wrapNativeSuper(Error));

module.exports = BottleneckError;